module.exports = __webpack_public_path__ + "static/media/icon-lock.85dbc3f3.svg";